import React__default from 'react';
import { g as getChannelTitle } from '../../chunks/bundle-DHLFKbb3.js';
import { u as useLocalization } from '../../chunks/bundle-BSUtC3cw.js';
import { G as GroupChannelListItemView } from '../../chunks/bundle-ClZdSyVW.js';
import { u as useGroupChannelList } from '../../chunks/bundle-BnnZK4c4.js';
import { u as useSendbird } from '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-j5GfJ6DZ.js';
import '../../chunks/bundle-DNwRc4lK.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-EMEHizdG.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-C6g3HNED.js';
import '../../chunks/bundle-C7OVXMkh.js';
import '../../chunks/bundle-D82dEh7Z.js';
import '../../chunks/bundle-CsFWohR-.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../ui/Badge.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../chunks/bundle-Bse9fZMw.js';
import '../../ui/MentionUserLabel.js';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-BIh7VduN.js';
import '../../chunks/bundle-CxpAk_cb.js';

var GroupChannelListItem = function (_a) {
    var _b, _c, _d;
    var channel = _a.channel, isSelected = _a.isSelected, isTyping = _a.isTyping, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbird().state.config;
    var stringSet = useLocalization().stringSet;
    var _e = useGroupChannelList().state, isTypingIndicatorEnabled = _e.isTypingIndicatorEnabled, isMessageReceiptStatusEnabled = _e.isMessageReceiptStatusEnabled;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (!((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.isAdminMessage()))
        && ((_d = (_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, channelName: getChannelTitle(channel, userId, stringSet), isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected, isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};

export { GroupChannelListItem };
//# sourceMappingURL=GroupChannelListItem.js.map
